import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastService, ToastType } from '../services/toast.service';
import { Router } from '@angular/router';
import { UserService } from '../services/authorization/user.service';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const router = inject(Router);
  const userService = inject(UserService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      handleError(error, toastService, router, userService);
      return throwError(() => error);
    })
  );
};

const handleError = (
  error: HttpErrorResponse,
  toastService: ToastService,
  router: Router,
  userService: UserService
): void => {
  const message = getErrorMessage(error, router, userService);
  toastService.showToast({
    type: ToastType.ERROR,
    message
  });
};

const getErrorMessage = (
  response: HttpErrorResponse,
  router: Router,
  userService: UserService
): string => {
  if (response.status === 401) {
    userService.clearUser();
    router.navigate(['/authorization']);
    return 'Authentication failed';
  }

  const serverError = response.error?.message || response.error?.error;
  return typeof serverError === 'string' && serverError.trim()
    ? serverError
    : 'An unexpected error occurred';
};
